import Text from 'components/_UI/Text'
import React from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/_UI/Icon';
import CONTACT from 'constants/contact';


export default function ContactContent() {
    const navigate = useNavigate();

    return (
        <PageWrapper>
            <BackButton onClick={() => navigate(-1)}>
                <IconWrap size='16px'>
                    <Icon name='back' color={colors.primary} />
                </IconWrap>
                <Text name='small' color={colors.primary}>Voltar</Text>
            </BackButton>

            <Header>
                <Text name='title'>Fale Conosco</Text>
                <Text color={colors.night}>
                    Respondemos de segunda a sexta, das 9h às 18h.
                </Text>
            </Header>

            <Cards>
                <ContactCard href={`mailto:${CONTACT.email}`}>
                    <CardIcon>
                        <IconWrap size='18px'>
                            <Icon name='mail' color={colors.primary} />
                        </IconWrap>
                    </CardIcon>
                    <CardBody>
                        <Text name='small' color={colors.nightLight} style={{ fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                            E-mail
                        </Text>
                        <Text name='highlight' color={colors.nightDark}>{CONTACT.email}</Text>
                    </CardBody>
                    <ChevronWrap>
                        <IconWrap size='14px'>
                            <Icon name='chevron-right' color={colors.nightLight} />
                        </IconWrap>
                    </ChevronWrap>
                </ContactCard>

                <ContactCard href={CONTACT.whatsapp} target='_blank' rel='noopener noreferrer'>
                    <CardIcon>
                        <IconWrap size='18px'>
                            <Icon name='whatsapp' color={colors.success} />
                        </IconWrap>
                    </CardIcon>
                    <CardBody>
                        <Text name='small' color={colors.nightLight} style={{ fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                            WhatsApp
                        </Text>
                        <Text name='highlight' color={colors.nightDark}>Clique para conversar</Text>
                    </CardBody>
                    <ChevronWrap>
                        <IconWrap size='14px'>
                            <Icon name='chevron-right' color={colors.nightLight} />
                        </IconWrap>
                    </ChevronWrap>
                </ContactCard>
            </Cards>
        </PageWrapper>
    )
}

const PageWrapper = styled(Column)`
    max-width: 560px;
    padding: 24px 30px 40px;
    gap: 0;
`;

const BackButton = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    width: fit-content;
    cursor: pointer;
    padding: 4px 0;
    transition: opacity .2s;

    & > p {
        padding-bottom: 0;
        line-height: 1;
    }

    &:hover {
        opacity: 0.7;
    }
`;

const Header = styled(Column)`
    margin-top: 28px;
    margin-bottom: 28px;
    gap: 6px;

    & > p {
        padding-bottom: 0;
    }
`;

const Cards = styled(Column)`
    gap: 12px;
    width: 100%;
`;

const ContactCard = styled.a`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 14px;
    padding: 14px 16px;
    border: 1px solid ${colors.occasionalGrey};
    border-radius: 10px;
    text-decoration: none;
    background: ${colors.neutralLight};
    transition: border-color .18s, box-shadow .18s;

    &:hover {
        border-color: ${colors.primary};
        box-shadow: 0 2px 10px rgba(63, 107, 198, 0.1);
    }
`;

const CardIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: ${colors.neutralBackground};
    flex-shrink: 0;
`;

const CardBody = styled(Column)`
    flex: 1;
    gap: 2px;

    & > p {
        padding-bottom: 0;
        margin: 0;
        line-height: 1.3;
    }
`;

const ChevronWrap = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

const IconWrap = styled.div`
    width: ${({ size }) => size || '20px'};
    height: ${({ size }) => size || '20px'};
    flex-shrink: 0;
`;
